import { useEffect, useSyncExternalStore } from 'react'
import type { Tema } from '@crm/shared'

/**
 * O tema da conta aplicado à página (ADR 0040). A classe `dark` no `<html>`
 * troca o valor das cores em `index.css`; a cópia no `localStorage` é o que o
 * `public/tema.js` lê no próximo carregamento, para não piscar branco.
 */
export function aplicarTema(tema: Tema): void {
  document.documentElement.classList.toggle('dark', tema === 'escuro')
  try {
    localStorage.setItem('crm-tema', tema)
  } catch {
    // Sem armazenamento, o tema vale até recarregar, e a conta reaplica.
  }
}

export function useTema(tema: Tema | undefined): void {
  useEffect(() => {
    if (tema) aplicarTema(tema)
  }, [tema])
}

function escuroAgora(): boolean {
  return document.documentElement.classList.contains('dark')
}

function assinarClasseDoHtml(aoMudar: () => void): () => void {
  const observador = new MutationObserver(aoMudar)
  observador.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })
  return () => observador.disconnect()
}

/**
 * O tema aplicado agora, para o que não se pinta pelas cores do CSS: o
 * editor do chatbot (React Flow) tem tema próprio, e o minimapa e os botões de
 * zoom ficavam brancos no modo escuro.
 */
export function useModoEscuro(): boolean {
  return useSyncExternalStore(assinarClasseDoHtml, escuroAgora, () => false)
}
